export default {
  Position: require('./position'),
  Slider: require('./slider'),
  Toggle: require('./toggle'),
/*  Range: require('./rangeslider'),
  Waveform: require('./waveform'), */
  Button: require('./button'),
  TextButton: require('./textbutton'),
  RadioButton: require('./radiobutton'),
  Number: require('./number'),
  Select: require('./select'),
  Dial: require('./dial'),
  Piano: require('./piano'),
  Sequencer: require('./sequencer'),
  Pan2D: require('./pan2d'),
  Tilt: require('./tilt'),
  Multislider: require('./multislider'),
  Pan: require('./pan'),
  Envelope: require('./envelope'),
  Spectrogram: require('./spectrogram'),
  Meter: require('./meter'),
  Oscilloscope: require('./oscilloscope')
};



// WEBPACK FOOTER //
// ./~/jshint-loader!./lib/interfaces/index.js